import { Component, OnInit } from '@angular/core';
import { ActiveQuotationsComponent } from '../../../page-quotation-cart/pages/active-quotations/active-quotations.component';

@Component({
    selector: 'app-page-active-quotations-list',
    templateUrl: './page-active-quotations-list.component.html',
    styleUrls: ['./page-active-quotations-list.component.scss'],
    standalone: true,
    imports: [ActiveQuotationsComponent]
})
export class PageActiveQuotationsListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
